module.exports = __webpack_public_path__ + "assets/img/section-2-landing-page-princess.24d89997.png";